import * as signalR from '@aspnet/signalr';

export default (() => {
  var Connection = new signalR.HubConnectionBuilder()
    .withUrl("/pollhub",{
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets
    })
    .configureLogging(signalR.LogLevel.Information)
    .build();

  var startPollHub = () => {
    if (Connection.state != signalR.HubConnectionState.Connected) {
      Connection.start().catch(err => {
        setTimeout(() => startPollHub(), 5000);
        console.log("No se puede conectar al servidor. Reintentando en 5 segundos.");
      });
    }
  }

  var stopPollHub = () => {
    Connection.stop().catch(err => console.log(err));
  }
  return {
    Connection,
    startPollHub,
    stopPollHub
  };
})();